// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefreshIntegrationDataForHouseholdMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  force: Types.Scalars['Boolean']['input'];
}>;


export type RefreshIntegrationDataForHouseholdMutation = { __typename?: 'Mutation', refreshIntegrationDataForHousehold: boolean };

export const Operations = {
  Mutation: {
    RefreshIntegrationDataForHousehold: 'RefreshIntegrationDataForHousehold' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const RefreshIntegrationDataForHouseholdDocument = gql`
    mutation RefreshIntegrationDataForHousehold($householdId: ID!, $force: Boolean!) {
  refreshIntegrationDataForHousehold(id: $householdId, force: $force)
}
    `;
export type RefreshIntegrationDataForHouseholdMutationFn = Apollo.MutationFunction<RefreshIntegrationDataForHouseholdMutation, RefreshIntegrationDataForHouseholdMutationVariables>;

/**
 * __useRefreshIntegrationDataForHouseholdMutation__
 *
 * To run a mutation, you first call `useRefreshIntegrationDataForHouseholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshIntegrationDataForHouseholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshIntegrationDataForHouseholdMutation, { data, loading, error }] = useRefreshIntegrationDataForHouseholdMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useRefreshIntegrationDataForHouseholdMutation(baseOptions?: Apollo.MutationHookOptions<RefreshIntegrationDataForHouseholdMutation, RefreshIntegrationDataForHouseholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshIntegrationDataForHouseholdMutation, RefreshIntegrationDataForHouseholdMutationVariables>(RefreshIntegrationDataForHouseholdDocument, options);
      }
export type RefreshIntegrationDataForHouseholdMutationHookResult = ReturnType<typeof useRefreshIntegrationDataForHouseholdMutation>;
export type RefreshIntegrationDataForHouseholdMutationResult = Apollo.MutationResult<RefreshIntegrationDataForHouseholdMutation>;
export type RefreshIntegrationDataForHouseholdMutationOptions = Apollo.BaseMutationOptions<RefreshIntegrationDataForHouseholdMutation, RefreshIntegrationDataForHouseholdMutationVariables>;